import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { getAuthType } from "../api";
import { AccountSelector } from "./AccountSelector";
import { PlatformSelector } from "./PlatformSelector";
import { TenantSelector } from "./TenantSelector";
import { UserMenu } from "./UserMenu";
import { COLLAPSED_WIDTH } from "./VerticalNavigation";

/**
 * Header - Top navigation bar composition
 *
 */
export const Header: React.FC = () => {
  const isOhid = getAuthType() === "ohid";

  return (
    <Box
      data-testid="header-container"
      sx={{
        position: "fixed",
        top: 0,
        left: COLLAPSED_WIDTH,
        width: `calc(100% - ${COLLAPSED_WIDTH}px)`,
        height: "var(--app-header-height)",
        boxSizing: "border-box",
        zIndex: 1100,
        background: "var(--color-bg-surface)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 3,
          py: 2.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            sx={{
              fontFamily: "EnterpriseSansVF, Arial, sans-serif",
              fontWeight: 700,
              fontSize: "23px",
              color: "var(--color-ink)",
              whiteSpace: "nowrap",
              borderRight: "1px solid var(--color-ink)",
              pr: 3,
              mr: 3,
              pt: "4px",
              pb: "4px",
            }}
          >
            Advanced Claim View
          </Typography>
          {isOhid ? <AccountSelector /> : <TenantSelector />}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
          {isOhid && <PlatformSelector />}
          <UserMenu />
        </Box>
      </Box>
    </Box>
  );
};
